const WISHLIST_ENDPOINT = '/apps/customer-wishlist';

function removeFromWishlist(link) {
  link.setAttribute('disabled', true);
  return fetch(WISHLIST_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      productsToDelete: [`gid://shopify/Product/${link.dataset.productId}`],
    }),
  })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => link.removeAttribute('disabled'));
}

function addToWishlist(link) {
  link.setAttribute('disabled', true);
  return fetch(WISHLIST_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      productsToAdd: [`gid://shopify/Product/${link.dataset.productId}`],
    }),
  })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => link.removeAttribute('disabled'));
}

function removeFromWishlistEvent() {
  const removeLinks = document.querySelectorAll('.card .remove-from-wishlist');
  removeLinks.forEach((link) => {
    if (link.dataset.productId) {
      link.addEventListener('click', () => {
        removeFromWishlist(link)
          .then((response) => {
            if (response.ok) {
              link.closest('.grid__item').remove();
            }
          })
          .catch((error) => {
            console.error(error);
          });
      });
    }
  });
}

function addToWishlistEvent(element) {
  const addLinks = element.querySelectorAll('.add-to-wishlist');
  addLinks.forEach((link) => {
    if (link.dataset.productId) {
      link.addEventListener('click', () => {
        if (link.classList.contains('add-to-wishlist--selected')) {
          removeFromWishlist(link)
            .then(() => {
              link.classList.remove('add-to-wishlist--selected');
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          addToWishlist(link)
            .then(() => {
              link.classList.add('add-to-wishlist--selected');
            })
            .catch((error) => {
              console.error(error);
            });
        }
      });
    }
  });
}

function wishlistEvents() {
  removeFromWishlistEvent();
  addToWishlistEvent(document);
}

wishlistEvents();
